import EventFinancesList from './EventFinancesList'
export default EventFinancesList